import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "1f2b7ceb-f4b7-41ff-a77e-6f6a0938878f", content: "Significance level", options: {} },
  { id: "754e34f5-215a-4737-b49a-c15338af09b5", content: "P-value", options: {} },
  { id: "2352f008-c664-4080-b23f-e361e6737779", content: "T-test statistic", options: {} },
];

const groups = [
  {
    id: "eec14d2b-f4d8-4ace-a870-4995213aeb3b",
    content: "Probability of rejecting the null hypothesis when in fact it is true.",
    options: {},
  },
  {
    id: "0914b93a-c556-4d71-ad39-217b327d5823",
    content:
      "Applied for normaly distributed data to determine if there is an statistical difference between the mean of two goups.",
    options: {},
  },
  {
    id: "2d04eac8-10c5-42c5-a460-1fffefe0994d",
    content: "Probability of obtaining a result as extreme or more, whenever the null hypothesis is true.",
    options: {},
  },
];

export const task: Task = {
  id: "55611381-b1bd-4ddd-bf37-205b1e52c2fa",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "eec14d2b-f4d8-4ace-a870-4995213aeb3b", itemsId: ["1f2b7ceb-f4b7-41ff-a77e-6f6a0938878f"] },
    { groupId: "0914b93a-c556-4d71-ad39-217b327d5823", itemsId: ["2352f008-c664-4080-b23f-e361e6737779"] },
    { groupId: "2d04eac8-10c5-42c5-a460-1fffefe0994d", itemsId: ["754e34f5-215a-4737-b49a-c15338af09b5"] },
  ],
};
